import React from 'react';
import { Brain, Leaf, Users, SlidersHorizontal } from 'lucide-react';
import Reveal from './Reveal';

const PILLARS = [
  {
    icon: Brain,
    num: '01',
    title: 'Entraînement cognitif',
    text: 'Plus de 50 jeux en ligne pour stimuler mémoire, concentration et résolution de problèmes — en accès illimité pendant 3 mois.',
  },
  {
    icon: SlidersHorizontal,
    num: '02',
    title: 'Plans personnalisés',
    text: 'Un programme bâti à partir de votre évaluation, pour avancer à votre rythme plutôt que de suivre un parcours générique.',
  },
  {
    icon: Leaf,
    num: '03',
    title: 'Pleine conscience',
    text: 'Des séances guidées pour apaiser le stress et cultiver un équilibre émotionnel durable, en complément des jeux.',
  },
  {
    icon: Users,
    num: '04',
    title: 'Soutien communautaire',
    text: 'Restez motivé aux côtés d’autres personnes engagées dans le même parcours de bien-être mental.',
  },
];

export default function Combinaison() {
  return (
    <section id="programme" className="py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-copper-600">
              La combinaison
            </p>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-tight">
              Quatre leviers, un seul programme.
            </h2>
            <p className="mt-5 text-clay text-lg leading-relaxed">
              IQ Brain Gamers réunit jeux cognitifs, plans adaptés, pratiques de
              calme et lien humain — une approche holistique du bien-être mental,
              un pas à la fois.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 gap-4 lg:gap-5">
          {PILLARS.map((item, i) => {
            const Icon = item.icon;
            return (
              <Reveal key={item.num} delay={i * 80}>
                <article className="h-full rounded-2xl border border-sand bg-paper p-6 sm:p-7 shadow-soft">
                  <div className="flex items-start justify-between gap-4">
                    <span className="w-11 h-11 rounded-lg bg-pine-100 text-pine-600 flex items-center justify-center">
                      <Icon size={20} />
                    </span>
                    <span className="font-mono text-xs text-clay">{item.num}</span>
                  </div>
                  <h3 className="mt-6 font-display text-2xl font-semibold">{item.title}</h3>
                  <p className="mt-3 text-clay leading-relaxed">{item.text}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
